import React, { Component} from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import debounce from 'lodash.debounce';

import api from 'api';
import { currentLanguage } from 'helpers';
import WP from 'WP';

import Heart from 'icons/HeartIcon';

import Container from 'partials/Container';
import GridElement from 'partials/GridElement';
import HotelCard from 'partials/HotelCard/HotelCard';
import Card from 'partials/Glider/Card';
import LinkCard from 'partials/LinkCard';
import MobileCard from 'partials/Glider/MobileCard';
import ErrorBoundary from 'partials/ErrorBoundary';
import Footer from 'partials/Footer';

import Media, { ScreenWidth } from 'css/Media';

class FavoritesPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
            favourites: [],
        };
    }

    componentWillMount() {
        window.scrollTo(0,0);
        this.checkScreenSize();
    }

    componentDidMount() {
        this.prepareFavourites();
        document.addEventListener('resize', debounce(() => this.checkScreenSize()),500);
    }

    componentWillUnmount() {
        document.removeEventListener('resize', this.checkScreenSize());
    }

    prepareFavourites = () => {
        const addToState = arr => {
            let favourites = this.state.favourites;
            arr.map(item => {
                favourites.push(item);
                this.setState({favourites: favourites});
                return null;
            })
        }

        if(this.props.favorites.hotels && this.props.favorites.hotels.length) {
            api.accommodationFetcher.getByIds({ids: this.props.favorites.hotels})
                .then(r => addToState(r.data))
        } else console.log('no favorite hotels');
        if(this.props.favorites.adventures && this.props.favorites.adventures.length) { 
            api.adventureFetcher.getByIds({ids: this.props.favorites.adventures})  
                .then(r => addToState(r.data))
        } else console.log('no favorite adventures');
        if(this.props.favorites.dining && this.props.favorites.dining.length) { 
            api.diningFetcher.getByIds({ids: this.props.favorites.dining})
                .then(r => addToState(r.data))
        } else console.log('no favorite dining');
        if(this.props.favorites.events && this.props.favorites.events.length) { 
            api.eventFetcher.getByIds({ids: this.props.favorites.events})
                .then(r => addToState(r.data))
        } else console.log('no favorite events')
        if(this.props.favorites.conference_venues && this.props.favorites.conference_venues.length) { 
            api.conferenceVenuesFetcher.getByIds({ids: this.props.favorites.conference_venues})
                .then(r => addToState(r.data))
        } else console.log('no favorite venues')
    }

    checkScreenSize() {
        let isMobile = false;

        if(ScreenWidth.lessThan('s')) {
            isMobile = true;
        }
        this.setState({
            isMobile: isMobile
        });
    }

    render() {
        const {
            favourites,
            isMobile
        } = this.state;

        return (
            <Wrapper>
                <Container grid>
                    <GridElement
                        colStart={{default: 1, s: 3}}
                        colEnd={{default: 8, s: 22}}s
                    >
                        { !favourites.length ?
                            currentLanguage() === 'no' ? 
                            <PageTitle><h1>Du har ingen favoritter ennå. <a href="/">Gå tilbake og finn deg noen.</a></h1></PageTitle>
                            : <PageTitle><h1>Nothing is added to your favorite list yet. <a href="/">Go back and change this.</a></h1></PageTitle>
                            : <PageTitle><h1>{WP.trans.myFavorites}</h1><Heart /></PageTitle>
                        }
                    </GridElement>
                </Container>
                { favourites.length ?
                        <Container grid>
                            { favourites.map((item,idx) => {
                                if(item.type === 'accommodation') {
                                    return (
                                        <CardGridElement
                                            colStart={{default: 1, s: idx%2 == 0 ? 3 : 13}}
                                            colEnd={{default: 8, s: idx%2 == 0 ? 12 : 22}}
                                            rowStart={{default: idx + 1, s: 'auto'}}
                                            key={idx}
                                        >
                                            <HotelCard
                                                key={item.id}
                                                hotel={item}
                                            />
                                        </CardGridElement>
                                    )
                                } else if(item.type === 'adventures') {
                                    if(!isMobile) {
                                        return (
                                            <CardGridElement
                                                colStart={{default: 1, s: idx%2 == 0 ? 3 : 13}}
                                                colEnd={{default: 8, s: idx%2 == 0 ? 12 : 22}}
                                                rowStart={{default: "auto"}}
                                                key={idx}
                                            >
                                                <ActivityCard
                                                    key={idx}
                                                    item={item}
                                                />
                                            </CardGridElement>
                                        )
                                    } else {
                                        return (
                                            <CardGridElement
                                                colStart={1}
                                                colEnd={8}
                                                rowStart={{default: "auto"}}
                                                key={idx}
                                            >
                                                <MobileActivityCard
                                                    item={item}
                                                />
                                            </CardGridElement>
                                        )
                                    }
                                    
                                } else if(item.type === 'dining' || item.type === 'events' || item.type === 'conference_venues') {
                                    return (
                                        <CardGridElement
                                            colStart={{default: 1, s: idx%2 == 0 ? 3 : 13}}
                                            colEnd={{default: 8, s: idx%2 == 0 ? 12 : 22}}
                                            rowStart={{default: "auto"}}
                                            key={idx}
                                        >
                                            <LinkCard
                                                key={idx}
                                                item={item}
                                                isMobile={isMobile}
                                            />
                                        </CardGridElement>
                                    )
                                } else return null;
                            })}
                        </Container>
                : null}
                <ErrorBoundary for="Footer">
                    <Footer/>
                </ErrorBoundary>
            </Wrapper>
        )
    }
}

const mapStateToProps = state => ({
    favorites: state.favorites,
})

export default connect(mapStateToProps, null)(FavoritesPage);


const Wrapper = styled.div`
    padding: ${props => props.theme.spacing.blockM} 0 ${props => props.theme.spacing.blockXS};
    
    ${Media.greaterThan('s')`
        padding: 240px 0 0;
    `}

    >.container {
        min-height: ${props => props.isEmpty ? '50vh' : 'none'};

        &:last-of-type {
            padding-bottom: ${props => props.theme.spacing.blockL};
        }
    }
`

const PageTitle = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: ${props => props.theme.spacing.elementS};

    h1 {
        ${props => props.theme.fonts.h2}
        margin-bottom: ${props => props.theme.spacing.contentL};

        a {
            color: ${props => props.theme.colors.link};
            text-decoration: underline;
            transition: all .2s ease;

            &:hover {
                text-decoration: none;
            }
        }
        ${Media.greaterThan('s')`
            margin-bottom: 0;
            margin-right: ${props => props.theme.spacing.contentXL};
        `}
    }

    svg {
        width: 28.97px;
        height: 26.1px;

        path {
            fill: ${props => props.theme.colors.text};
        }

        ${Media.greaterThan('s')`
            width: 39.28px;
            height: 35.39px;
        `}
    }

    ${Media.greaterThan('s')`
        justify-content: center;
        flex-direction: row;
        padding-bottom: ${props => props.theme.spacing.blockS};
    `}
`

const CardGridElement = styled(GridElement)`
    padding-bottom: ${props => props.theme.spacing.elementL};

    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.blockS};
    `}
`

const ActivityCard = styled(Card)`
    padding-right: 0;
`

const MobileActivityCard = styled(MobileCard)`
    padding-right: 0;
`